import apiClient from '../api-client';

export const getRecommendedPages = () => apiClient.get('page/recommended').then(res => res.data);
export const getPage = (slug) => apiClient.get('page/' + slug).then(res => res.data);
